var React = require('react');
var TableConcept = React.createClass({
    getInitialState: function() {
        return {
            collection: this.props.data,
            conceptsMap: this.props.conceptsMap,
            courses: this.props.courses,
            tableConcept: this.props.tableConcept,
            tableQuestion: this.props.tableQuestion
        };
    },
    genarateRow(title1, title2, Concept, title1Old, title2Old, rowSpan1, rowSpan2) {
        var isSpan1, isSpan2 = false;
        if (title1 !== title1Old) {
            isSpan1 = true;
        }
        if (title2 !== title2Old) {
            isSpan2 = true;
        }
        return (

            <tr>
                {isSpan1&&
                  <td className="main-text" rowSpan={rowSpan1}>{title1}</td>
                }
                {isSpan2&&
                  <td className="main-text" rowSpan={rowSpan2}>{title2}</td>
                }
                {isSpan1&&Concept.isEmpty&&
                    <td className="main-text" rowSpan={rowSpan1}></td>
                }
                {!Concept.isEmpty&&
                    <td className="main-text">{Concept.title}</td>
                }

                {!Concept.isEmpty&&
                  <td className="main-text">{Concept.Proportion.toFixed(2)}</td>
                }
                {isSpan1&&Concept.isEmpty&&
                  <td className="main-text" rowSpan={rowSpan1}> </td>
                }

                {isSpan1&&
                  <td className="main-text" rowSpan={rowSpan1}>{Concept.ProportionRoot.toFixed(2)}</td>
                }
              </tr>
        );
    },
    genarateTableConcept(tableConcept) {
        {
            var rows = [];
            var _this = this;
            var title1Old, title2Old = "";
            Object.keys(tableConcept).forEach(function(key) {
                if (tableConcept[key].title) {
                    var tableConcept1 = tableConcept[key];
                    var title1 = tableConcept1.title;
                    var rowSpan1 = 0;
                    Object.keys(tableConcept1).forEach(function(key) {
                        if (tableConcept1[key].countChild) {
                            rowSpan1 += tableConcept1[key].countChild;
                        }
                    })
                    Object.keys(tableConcept1).forEach(function(key) {
                        if (tableConcept1[key].title) {
                            var tableConcept2 = tableConcept1[key];
                            var title2 = tableConcept2.title;
                            var rowSpan2 = tableConcept2.countChild;
                            Object.keys(tableConcept2).forEach(function(key) {
                                if (tableConcept2[key].title) {
                                    if (tableConcept2[key].title == "empty") {
                                        var tableConcept3 = tableConcept2.empty;
                                        tableConcept3.Proportion = 0;
                                        tableConcept3.ProportionRoot = tableConcept1.count * 100 / tableConcept.count;
                                        tableConcept3.isEmpty = true;
                                        rows.push(
                                            _this.genarateRow(title1, title2, tableConcept3, title1Old, title2Old, rowSpan1, rowSpan2)
                                        );
                                    } else {
                                        var tableConcept3 = tableConcept2[key];
                                        tableConcept3.Proportion = tableConcept3.count * 100 / tableConcept.count;
                                        tableConcept3.ProportionRoot = tableConcept1.count * 100 / tableConcept.count;
                                        tableConcept3.isEmpty = false;
                                        rows.push(
                                            _this.genarateRow(title1, title2, tableConcept3, title1Old, title2Old, rowSpan1, rowSpan2)
                                        );
                                    }

                                    title1Old = title1;
                                    title2Old = title2;
                                }

                            })
                        }

                    })
                }
            })
        }
        return rows;
    },
    genarateRowTableQuestion(title1, title2, Question, title1Old, title2Old, rowSpan1, rowSpan2) {
        var isSpan1, isSpan2 = false;
        if (title1 !== title1Old) {
            isSpan1 = true;
        }
        if (title2 !== title2Old) {
            isSpan2 = true;
        }
        return (
            <tr>
                  
                {isSpan2&&
                  <td className="main-text" rowSpan={rowSpan2}>{title2}</td>
                }
                <td className="main-text">{Question.count}</td>
                <td className="main-text">{Question.title}</td>
                <td className="main-text">{Question.Proportion.toFixed(2)}</td>
                {isSpan1&&
                    <td className="main-text" rowSpan={rowSpan1}>{title1}</td>
                }
              </tr>
        );
    },
    genarateTableQuestion(tableQuestion) {
        var rows = [];
        var _this = this;
        var title1Old, title2Old = "";
        Object.keys(tableQuestion).forEach(function(key) {
            if (tableQuestion[key].count) {
                var tableQuestion1 = tableQuestion[key];
                var rowSpan1 = 0;
                Object.keys(tableQuestion1).forEach(function(key) {
                    if (tableQuestion1[key].countChild) {
                        rowSpan1 += tableQuestion1[key].countChild;
                    }
                })
                Object.keys(tableQuestion1).forEach(function(key) {
                    if (tableQuestion1[key].count) {
                        var tableQuestion2 = tableQuestion1[key];
                        var rowSpan2 = tableQuestion2.countChild;
                        Object.keys(tableQuestion2).forEach(function(key) {
                            if (tableQuestion2[key].count) {
                                var tableQuestion3 = tableQuestion2[key];
                                tableQuestion3.Proportion = tableQuestion3.count * 100 / tableQuestion.count;
                                rows.push(
                                    _this.genarateRowTableQuestion(tableQuestion1.title, tableQuestion2.title, tableQuestion3, title1Old, title2Old, rowSpan1, rowSpan2)
                                );
                                title1Old = tableQuestion1.title;
                                title2Old = tableQuestion2.title;
                            }
                        })
                    }

                })
            }
        })
        return rows;
    },
    render: function() {
        var _this = this;
        var tableConcept = _this.props.tableConcept;
        var tableQuestion = _this.props.tableQuestion;
        return (
            <div className="col-md-5 table-concept ">
                    <span className='head-title'>The Proportion of Concepts</span> <span className='head-value'>(Total Concept: {tableConcept.countConcept})</span>
                      <table className="table table-bordered table-concept">
                          <thead className="header-exam-editor">
                            <tr>
                              <th>Main Concept</th>
                              <th>Sub Concept Level 1</th>
                              <th>Sub Concept Level 2</th>
                              <th>Proportion of each Subconcept</th>
                              <th>Proportion of Main Concept</th>
                            </tr>
                          </thead>
                          <tbody>
                            {_this.genarateTableConcept(tableConcept)}
                          </tbody>
                    </table>
                    <span className='head-title'>The Proportion of Type of Quesstion</span> <span className='head-value'>(Total Quesstion: {tableQuestion.count})</span>
                    <table className="table table-bordered table-concept">
                          <thead className="header-exam-editor">
                            <tr>
                              <th>Item Type</th>
                              <th>Number of Qn</th>
                              <th>Number of Marks per Qn</th>
                              <th>Weighting</th>
                              <th>Duration</th>
                            </tr>
                          </thead>
                          <tbody>
                            {_this.genarateTableQuestion(tableQuestion)}
                          </tbody>
                    </table>
            </div>
        )
    }
})

export default TableConcept;



/** WEBPACK FOOTER **
 ** ./src/components/ExamEditor/TableConcept.js
 **/